import { useNavigate } from 'react-router-dom'
import { BodyText, OtherText } from 'styling/Typography'
import { SourceBadge } from 'pages/Operations/Shared/OpsSharedComponents'
import { deptName } from 'pages/Operations/Shared/opsDepartments'
import { ITimelineEventRowProps } from 'types/opsTimeline.interface'
import { DEPARTMENT_LABEL, KIND_LABEL } from './timelineMeta'
import {
  DepartmentTag,
  DotCell,
  EventCard,
  EventRow,
  KindChip,
  MetaRow,
  OpenHint,
  SeverityDot,
  TimeCell,
  TitleRow,
} from './OpsTimeline.styled'

export const TimelineEventRow = ({ event }: ITimelineEventRowProps) => {
  const navigate = useNavigate()

  const linkTarget = event.fuelMachineId ? `/fuel/machines/${event.fuelMachineId}` : event.linkPath

  const handleOpen = () => {
    if (linkTarget) navigate(linkTarget)
  }

  return (
    <EventRow>
      <TimeCell>{event.time}</TimeCell>
      <DotCell>
        <SeverityDot $tone={event.severity} />
      </DotCell>
      <EventCard $clickable={!!linkTarget} onClick={linkTarget ? handleOpen : undefined}>
        <TitleRow>
          <BodyText weight='600'>{event.title}</BodyText>
          <KindChip>{KIND_LABEL[event.kind]}</KindChip>
          {linkTarget && <OpenHint>Open ›</OpenHint>}
        </TitleRow>
        <OtherText grey>{event.description}</OtherText>
        {((event.source && !event.deptTo) || event.department) && (
          <MetaRow>
            {event.source && !event.deptTo && <SourceBadge source={event.source} />}
            {event.department && (
              <DepartmentTag>
                {event.deptTo
                  ? `${deptName(event.department)} → ${deptName(event.deptTo)}`
                  : DEPARTMENT_LABEL[event.department]}
              </DepartmentTag>
            )}
          </MetaRow>
        )}
      </EventCard>
    </EventRow>
  )
}
